import Vue from 'vue'
import App from '@/App'
import router from './router'
import store from './store/store'
import titleMixin from './mixins/titleMixin'
import VueLocalStorage from 'vue-ls'
import VueClipboard from 'vue-clipboard2'
import VueI18n from 'vue-i18n'
import { VueReCaptcha } from 'vue-recaptcha-v3'
import { CustomizationLoader } from 'CustomModules/loader'
import CoreLangLoader from './lang/LangLoader'
import UserCan from '@/plugins/UserCan'

import DtTable from '@/components/ui/table/DtTable'
import DataTables from '@/components/ui/datatables/DataTables'
import Calendar from '@/components/ui/calendar/calendar'
import DropDown from '@/components/ui/dropdown/dropdown'
import Error from '@/components/ui/error/Error'
import ConfirmModal from '@/components/ui/confirm-modal/ConfirmModal'
import CreaEditaTipos from '@/components/GrupoTipos/CreaEditaTipos'
import CreaEditaGrupoTipos from '@/components/GrupoTipos/CreaEditaGrupoTipos'

import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/antd.css'

// import 'datatables.net-se/css/dataTables.semanticui.css'
// import '../semantic/dist/semantic.min.css'

import './assets/core.css'
// import './assets/ant-fix.css'

// require('semantic')
require('datatables.net')
// require('datatables.net-se')
// require('semantic-calendar')
// require('semantic-calendar-css')
require('moment')
// require('noty-css')
// require('noty-theme-css')

// require('./util/VueJsUtils')
require('./util/MomentLocale')
moment.locale('es')

Vue.config.productionTip = false
Vue.use(VueLocalStorage)
Vue.use(VueClipboard)
Vue.use(VueI18n)
Vue.use(UserCan)
Vue.use(Antd)

/* google recaptcha */
if (store.state.appSettings.recaptcha.enabled) {
  Vue.use(VueReCaptcha, {
    siteKey: store.state.appSettings.recaptcha.site_key,
    loaderOptions: store.state.appSettings.recaptcha.loaderOptions
  })
}

/* Componentes globales */
Vue.component('dt-table', DtTable)
Vue.component('data-table', DataTables)
Vue.component('calendar', Calendar)
Vue.component('dropdown', DropDown)
Vue.component('error', Error)
Vue.component('confirm-modal', ConfirmModal)
Vue.component('crea-edita-grupo-tipos', CreaEditaGrupoTipos)
Vue.component('crea-edita-tipos', CreaEditaTipos)

/* Carga los componentes de la customization */
let registeredComponents = []
CustomizationLoader.paths.forEach((path) => {
  let customComponents = require(`CustomModules/${path}/components`)
  customComponents.Components.forEach((comp) => {
    if (!registeredComponents.includes(comp.name)) {
      Vue.component(comp.name, comp.component)
      registeredComponents.push(comp.name)
    }
  })

  /* Carga los plugins */
  try {
    let customPlugins = require(`CustomModules/${path}/plugins`)
    customPlugins.Plugins.forEach((comp) => {
      Vue.use(comp)
    })
  } catch (ex) {}
})

let i18n = CoreLangLoader.getInstance()

Vue.mixin(titleMixin)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  i18n,
  store,
  router,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js